import { isCustomAuth } from '../../experiments/customAuth/utils';
import { UniversalCart } from '../../scripts/blocks/store/cart/UniversalCart';
import { StoreAPIDataService } from '../../scripts/blocks/store/services/StoreAPIDataService';
import { toggleElement } from '../../scripts/helpers/common';
import { ANTIFRAUD_LIMIT_NUMBER } from '../cart/constants';

import { StoreItem } from '#common/types/store';

export const updateHidingButtons = ({
  addToCartButton,
  buyButton,
  checkoutButton,
  cart,
  sku,
  storeAPIDataService,
}: {
  addToCartButton?: HTMLElement;
  buyButton: HTMLElement;
  checkoutButton: HTMLElement;
  cart: UniversalCart;
  sku: string;
  storeAPIDataService: StoreAPIDataService;
}): void => {
  const foundItem = storeAPIDataService.findBySku(sku) as StoreItem;
  if (!foundItem) {
    throw new Error(
      `Store item was not found in the list received when updating the cart ; SKU – ${sku}`
    );
  }

  const showButton = isCustomAuth()
    ? !cart.hasSKU(foundItem.sku) ||
      (cart.hasSKU(foundItem.sku) &&
        cart.getItemBySKU(foundItem.sku).quantity < ANTIFRAUD_LIMIT_NUMBER)
    : !cart.hasSKU(foundItem.sku);

  if (addToCartButton) {
    toggleElement(addToCartButton, () => showButton);
  }
  toggleElement(buyButton, () => showButton);
  toggleElement(checkoutButton, () => !showButton);
};
